import { CiStar } from "react-icons/ci";

export const ElementData = [ 
    {
        type: "Aqua", 
        image: "/exedra-icons/elements/aqua-elem.png"
    },
    {
        type:"Dark",
        image: "/exedra-icons/elements/dark-elem.png",
    },
    {
        type:"Flame",
        image: "/exedra-icons/elements/flame-elem.png",

    },
    {
        type:"Forest",
        image: "/exedra-icons/elements/forest-elem.png",
    },
    {
        type:"Light",
        image: "/exedra-icons/elements/light-elem.png",
    },
    {
        type:"Void",
        image: "/exedra-icons/elements/void-elem.png",
    }
]

export const RoleData = [
    {
        role:"Attacker",
        image:"/exedra-icons/role/attacker.png"
    },
    {
        role:"Breaker",
        image:"/exedra-icons/role/breaker.png"
    },
    {
        role:"Buffer",
        image:"/exedra-icons/role/buffer.png"

    },
    {
        role:"Debuffer",
        image:"/exedra-icons/role/debuffer.png"

    },
    {
        role:"Defender",
        image:"/exedra-icons/role/defender.png"

    },
    {
        role:"Healer",
        image:"/exedra-icons/role/healer.png"
    }
]

export const RarityData= [
    {
        rarity: "5",
        icon: <CiStar />
    },
    {
        rarity: "4",
        icon: <CiStar />
    },
    {
        rarity: "3",
        icon: <CiStar />
    }    
]